import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";

const KEY = "veyrone-cookie-consent";

// GDPR cookie banner. The site only sets strictly-necessary local storage
// (language + this consent record); analytics stay off until accepted.
export default function CookieBanner() {
  const { t } = useLang();
  const c = t("nx.cookie");
  const [visible, setVisible] = useState(false);
  const [openPrefs, setOpenPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(KEY); } catch {}
    if (!stored) setVisible(true);
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({
        choice,
        analytics: choice === "all" ? true : choice === "essential" ? false : analytics,
        at: new Date().toISOString(),
      }));
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] bg-[#0D0E0F]/95 backdrop-blur-sm border-t border-white/15" data-testid="cookie-banner">
      <div className="px-5 md:px-10 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-[12px] text-[#999995] leading-relaxed md:max-w-2xl" data-testid="cookie-text">{c.body}</p>
        <div className="flex flex-wrap gap-2 md:ml-auto">
          <button onClick={() => decide("all")} className="btn btn-solid !py-2 !px-5" data-testid="cookie-accept">{c.accept}</button>
          <button onClick={() => decide("essential")} className="btn !py-2 !px-5" data-testid="cookie-reject">{c.reject}</button>
          <button onClick={() => setOpenPrefs(!openPrefs)} className="btn !py-2 !px-5" data-testid="cookie-prefs-toggle">{c.prefs}</button>
        </div>
      </div>
      {openPrefs && (
        <div className="px-5 md:px-10 pb-6 border-t border-white/10 pt-5 space-y-3" data-testid="cookie-preferences">
          <label className="flex items-start gap-3 text-[12px] text-[#666663]">
            <input type="checkbox" checked disabled className="w-[14px] h-[14px] mt-[2px] accent-[#D1C7BD]" data-testid="cookie-essential" />
            <span><span className="mono text-[11px] tracking-[0.14em] text-[#999995] uppercase">{c.essential}</span> — {c.essentialDesc}</span>
          </label>
          <label className="flex items-start gap-3 text-[12px] text-[#999995] cursor-pointer">
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="w-[14px] h-[14px] mt-[2px] accent-[#D1C7BD] cursor-pointer" data-testid="cookie-analytics" />
            <span><span className="mono text-[11px] tracking-[0.14em] text-[#F3F3F0] uppercase">{c.analytics}</span> — {c.analyticsDesc}</span>
          </label>
          <button onClick={() => decide("custom")} className="btn btn-solid !py-2 !px-5" data-testid="cookie-save">{c.save}</button>
        </div>
      )}
    </div>
  );
}
